import { formatarParaMoedaBRL } from "../../../utils";
import { ListDescriptions } from "../../../components/ListDescriptions";
import { Panel } from "primereact/panel";
 
interface NaturezaDivida {
  total: number;
  debitos: any[];
  status: string | null;
  natureza: string | null;
  numeroInscricao: string;
  tipoDivida: string | null;
  tipoCredito: string | null;
  dataInscricao: string | null;
  receitaPrincipal: string | null;
  unidadeInscricao: string | null;
  situacaoInscricao: string | null;
  entidadeResponsavel: string | null;
}
 
interface DadosDevedor {
  uf: string;
  nome: string;
  status: string;
  tipoPessoa: string;
  totalDivida: number;
  possuiDivida: boolean;
  codigoMunicipio: number;
  tipoDevedor: string | null;
  naturezas: NaturezaDivida[];
  documentoConsultado: string;
  totalTributario: number | null;
  unidadeResponsavel: string | null;
}
 
interface DadoFormatado {
  label: string;
  value: string | null;
}
 
interface CategoriaDados {
  categoria: string;
  dados: DadoFormatado[];
}
 
function formatarDadosDevedor(dados: DadosDevedor): CategoriaDados[] {
  const dividas = dados.naturezas.map((natureza, index) => ({
    categoria: `Dívida ${index + 1}`,
    dados: [
      { label: "Número de Inscrição", value: natureza.numeroInscricao },
      { label: "Total", value: formatarParaMoedaBRL(natureza.total) },
      { label: "Situação da Inscrição", value: natureza.situacaoInscricao },
      { label: "Receita Principal", value: natureza.receitaPrincipal },
      { label: "Tipo de Dívida", value: natureza.tipoDivida },
      { label: "Data de Inscrição", value: natureza.dataInscricao },
      { label: "Unidade de Inscrição", value: natureza.unidadeInscricao },
    ],
  }));
 
  return [
    {
      categoria: "Informações do Devedor",
      dados: [
        { label: "Nome", value: dados.nome },
        { label: "Documento Consultado", value: dados.documentoConsultado },
        { label: "UF", value: dados.uf },
        { label: "Tipo de Pessoa", value: dados.tipoPessoa },
        { label: "Possui Dívida", value: dados.possuiDivida ? "Sim" : "Não" },
        {
          label: "Total da Dívida",
          value: formatarParaMoedaBRL(dados.totalDivida),
        },
        { label: "Status", value: dados.status },
      ],
    },
    ...dividas,
  ];
}
 
export function DevedorUniao({ data }: { data: DadosDevedor }) {
  return (
    <Panel header= "Devedores da União">
      {formatarDadosDevedor(data).map(({ dados, categoria }) => (
        <ListDescriptions dados={dados} key={categoria} categoria={categoria} />
      ))}
    </Panel>
  );
}